import React, { useState, useEffect } from "react"
import Svg from "../../_svgs/svg"

export default function Locations({
  locations,
  selectLocations,
  selectedLocations,
  clearFilteringLabel,
  filters,
  clearFilters,
  merchants,
  isKeyboardNavigating,
  locationsOpen,
  dropDownRef,
  handleBlur,
}) {
  const getClearedLocations = () => {
    return locations.reduce(
      (acc, location) => ({
        ...acc,
        [location]: false,
      }),
      {},
    )
  }

  const [disableInput, setDisableInput] = useState(false)
  const [beforeSecurityChecked, setBeforeSecurityChecked] = useState(false)
  const [afterSecurityChecked, setAfterSecurityChecked] = useState(false)
  const [locationsChecked, setLocationsChecked] = useState(getClearedLocations())

  useEffect(() => {
    if (selectedLocations !== "") {
      if (selectedLocations === "before-security") {
        setBeforeSecurityChecked(true)
        setDisableInput(true)
      } else if (selectedLocations === "after-security") {
        setAfterSecurityChecked(true)
        setDisableInput(true)
      } else {
        const locationsSelected = selectedLocations.split(",")
        const checkedLocations = locationsSelected.reduce((obj, item) => {
          obj[item] = true
          return obj
        }, {})
        setLocationsChecked(checkedLocations)
      }
    }
  }, [selectedLocations])

  useEffect(() => {
    if (beforeSecurityChecked || afterSecurityChecked) {
      const resetLocations = Object.keys(locationsChecked).reduce(
        (acc, key) => ({
          ...acc,
          [key]: false,
        }),
        {},
      )
      setLocationsChecked(resetLocations)
    }
  }, [beforeSecurityChecked, afterSecurityChecked])

  useEffect(() => {
    setDisableInput(beforeSecurityChecked || afterSecurityChecked)
  }, [beforeSecurityChecked, afterSecurityChecked])

  useEffect(() => {
    if (beforeSecurityChecked) {
      selectLocations("before-security")
    } else if (afterSecurityChecked) {
      selectLocations("after-security")
    } else {
      const checkedLocations = Object.entries(locationsChecked)
        .filter(([key, value]) => value)
        .map(([key]) => key)
      selectLocations(checkedLocations.length > 0 ? checkedLocations.join(",") : "")
    }
  }, [locationsChecked, beforeSecurityChecked, afterSecurityChecked])

  const handleBeforeSecurityChange = (e) => {
    setBeforeSecurityChecked(e.target.checked)
    if (e.target.checked) {
      setAfterSecurityChecked(false)
    }
  }

  const handleAfterSecurityChange = (e) => {
    setAfterSecurityChecked(e.target.checked)
    if (e.target.checked) {
      setBeforeSecurityChecked(false)
    }
  }

  const handleLocationChange = (location, checked) => {
    setLocationsChecked((prev) => ({
      ...prev,
      [location]: checked,
    }))
  }

  const resetFilters = () => {
    setDisableInput(false)
    setBeforeSecurityChecked(false)
    setAfterSecurityChecked(false)
    setLocationsChecked(getClearedLocations())
    clearFilters()
  }

  return (
    <div className={`locations${locationsOpen ? " open" : " closed"}`}>
      <div className={`options${isKeyboardNavigating ? " focus-visible" : ""}`} role="listbox" ref={dropDownRef} onBlur={handleBlur}>
        {locations &&
          locations.map((location, index) => {
            const inputId = index === 0 ? "before-security-input" : index === 1 ? "after-security-input" : `location-${location}`
            return (
              <span key={location} className={`option${filters.length > 0 && index == 0 ? " show-clear-filters" : ""}`}>
                <input
                  type="checkbox"
                  tabIndex={locationsOpen ? 0 : -1}
                  id={inputId}
                  aria-label={inputId}
                  name={location}
                  value={location}
                  checked={index === 0 ? beforeSecurityChecked : index === 1 ? afterSecurityChecked : locationsChecked[location]}
                  aria-selected={index === 0 ? beforeSecurityChecked : index === 1 ? afterSecurityChecked : locationsChecked[location] || false}
                  role="option"
                  onChange={
                    index === 0
                      ? handleBeforeSecurityChange
                      : index === 1
                        ? handleAfterSecurityChange
                        : (e) => handleLocationChange(location, e.target.checked)
                  }
                  disabled={
                    index == 0 && !merchants.some((m) => m.isAirSide == false)
                      ? true
                      : index < 2
                        ? false
                        : !merchants.some((m) => m.shopLocation === location) || disableInput
                  }
                />
                <label htmlFor={inputId}>{location}</label>
              </span>
            )
          })}
        {filters.length > 0 && (
          <button className="remove-filters" onClick={resetFilters} tabIndex={locationsOpen ? 0 : -1}>
            <p>{clearFilteringLabel}</p>
            <span>
              <Svg iconName={"clear-button"} />
            </span>
          </button>
        )}
      </div>
    </div>
  )
}
